export default "/assets/images/the-critter-cuddler.279a96f72c9565da.webp";